import React from "react";
import { Helmet } from "react-helmet-async";
import OurProcess from "../components/Interior/Process";
import AboutUs from "../components/Interior/AboutUs";
import Story from "../components/Interior/Story";
import InteriorBanner from "../components/Interior/InteriorBanner";
import Design from "../components/Interior/Design";
import ImgCompare from "../components/Interior/ImgCompare";
import FollowUs from "../components/Interior/FollowUs";

const Interior = () => {
  const isAppPath = window.location.pathname === "/app-interior";

  return (
    <>
      <Helmet>
        <title>
          {`Architecture & Interior | ${process.env.REACT_APP_APP_NAME}`}
        </title>
      </Helmet>
      <InteriorBanner />
      <Story />
      <Design />
      {!isAppPath && <AboutUs />}
      <OurProcess />
      <ImgCompare />
      <FollowUs />
    </>
  );
};

export default Interior;
